import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { CookieService } from 'ngx-cookie';

@Component({
  selector: 'app-datetime',
  templateUrl: './datetime.component.html',
  styleUrls: ['./datetime.component.scss']
})
export class DatetimeComponent implements OnInit, AfterViewInit {

  get language() {
    this.storage.retrieve(localStorage.getItem('changedLanguage'));
    return Number(localStorage.getItem('changedLanguage'));
  }
  @ViewChild('validationForm') validationForm: any = false;

  @Input() formItem: any;
  @Input() invalidForm: any;
  @Input() formId:any;

  @Output() invalidFormChange = new EventEmitter<boolean>();

  isRequired: boolean;
  formTitle: string;
  dateValue: any;
  languageId: number = 1;

  constructor(private storage: LocalStorageService, private cookieService: CookieService) {

  }

  ngOnInit() {
    this.languageId = Number(this.cookieService.get('formLanguage'));
    delete this.formItem.boolValue;
    this.isRequired = this.formItem.item.isRequired;
    this.formTitle = this.formItem.item.labelField;
    this.formItem.value = this.formItem.value ? new Date(this.formItem.value) : new Date();
  }

  ngAfterViewInit() {
    if (this.isRequired) {
      this.validationForm.control.statusChanges.subscribe((status) => {
        this.invalidFormChange.emit(this.validationForm.invalid);
      });
    }
  }

  getLabel() {
      try {
          let optionFound = this.formItem.item.itemLabels.filter(x => x.language !== null && x.language !== undefined && x.language.idLanguage === this.languageId)[0];
          if (optionFound?.labelField && optionFound.labelField !== '')
            return optionFound.labelField;
          else {
            return this.formItem.item.itemLabels[0].labelField;
          }
      }
      catch (Exception) {
        console.log("ERROR LABELS");
        return '';
      }
    }

}
